import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";

const aiRiskControlRouter: RouteRecordRaw[] = [
    {
        path: "/aiRiskControl",
        name: "AiRiskControl",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/aiRiskControl/dashboard",
        meta: {
            title: "风控管理",
            icon: "icon-AI"
        },
        children: [
            {
                path: "/aiRiskControl/warehouseSupervision",
                name: "AiWarehouseSupervision",
                component: () => import("@/views/pages/aiRiskControl/warehouseSupervision/index.vue"),
                meta: {
                    title: "仓库监管",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_SUPERVISION_R"
                        }
                    ]
                }
            },
            {
                path: "/aiRiskControl/cameraManagement",
                name: "CameraManagement",
                component: () => import("@/views/pages/aiRiskControl/cameraManagement/index.vue"),
                meta: {
                    title: "设备管理",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    activeMenu: "CameraManagement",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_EQUIPMENT_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_EQUIPMENT_W"
                        }
                    ]
                }
            },
            {
                path: "/aiRiskControl/cameraAdd",
                name: "CameraAdd",
                component: () => import("@/views/pages/aiRiskControl/cameraManagement/form.vue"),
                meta: {
                    title: "新增设备",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    activeMenu: "CameraManagement",
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_EQUIPMENT_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_EQUIPMENT_R"
                        }
                    ]
                }
            },
            {
                path: "/aiRiskControl/cameraEdit/:id",
                name: "CameraEdit",
                component: () => import("@/views/pages/aiRiskControl/cameraManagement/form.vue"),
                meta: {
                    title: "编辑设备",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    activeMenu: "CameraManagement",
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_EQUIPMENT_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_EQUIPMENT_R"
                        }
                    ]
                }
            },
            {
                path: "/aiRiskControl/cameraDetail/:id",
                name: "CameraDetail",
                component: () => import("@/views/pages/aiRiskControl/cameraManagement/detail.vue"),
                meta: {
                    title: "设备详情",
                    isNotShowHeader: true,
                    activeMenu: "CameraManagement",
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_EQUIPMENT_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_EQUIPMENT_R"
                        }
                    ]
                }
            },
            {
                path: "/aiRiskControl/aiAssistant",
                name: "AiAssistant",
                component: () => import("@/views/pages/aiRiskControl/aiAssistant/index.vue"),
                meta: {
                    title: "AI助手",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "/dataAnalysis/creditEvaluation",
                name: "CreditEvaluation",
                component: () => import("@/views/pages/aiRiskControl/creditEvaluation/index.vue"),
                meta: {
                    title: "信用评估",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "/dataAnalysis/riskEvaluation",
                name: "RiskEvaluation",
                component: () => import("@/views/pages/aiRiskControl/riskEvaluation/index.vue"),
                meta: {
                    title: "风险评估",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            }
        ]
    }
];

export default aiRiskControlRouter;
